import * as yup from "yup";

export const signModalSchema = yup.object({
    sign_size_uuid: yup
        .object({
            label: yup.string().required("Sign Size label is required."),
            value: yup.string().required("Sign Size  is required."),
        })
        .required("Sign Size is required."),
    sign_uuid: yup
        .object({
            label: yup.string().required("Sign Style label is required."),
            value: yup.string().required("Sign Style  is required."),
        })
        .required("Sign Style is required."),
    sign_for: yup
        .object({
            label: yup.string().required("Sign For label is required."),
            value: yup.number().required("Sign For is required."),
        })
        .required("Sign For is required."),

});